import React from "react";
import { BrowserRouter } from "react-router-dom";
//import Navigation from "./components/navigation/navigation";
import Content from './components/content/content'
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import blue from '@material-ui/core/colors/blue';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import HeaderComponent from './components/header/headerComponent';
import * as Constants from './common/constants';
import preval from 'preval.macro';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import * as actionTypes from './store/actionTypes';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { bgBG } from '@material-ui/core/locale';

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: '0px'
      }
    },
    MuiIconButton: {
      root: {
        padding: '0px',
        paddingRight: '5px'
      }
    },
    MuiTypography: {
      h6: {
        fontSize: '1.2em'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '90% !important'
      },
      paperFullWidth: {
        width: '100%'
      }
    },
    MuiFab: {
      root: {
        boxShadow: '1px'
      }
    },
    MuiButton: {
      root: {
        minWidth: 50
      }
    }
  },
  palette: {
    primary: blue
  },
}, bgBG);

const App: React.FC = (props: any) => {
  //let isPlanner = false;
  const newDate = preval`module.exports = new Date()`;
  const buildDate = format(new Date(newDate), 'yyyyMMdd');

  return (
    <>
      <BrowserRouter>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className="app">
              <HeaderComponent />
              {/* <button onClick={() => props.setPlanner(true)}>2D</button> */}
              {/* <Navigation /> */}
              <div className="app-content">
                <Content />
              </div>
              <div className="app-footer">
                © {new Date().getFullYear()} ICB - InterConsult Bulgaria All rights reserved, ver.
              {Constants.version}.{Constants.buildNumber === "YYYYMMDD" ? buildDate : Constants.buildNumber}
              </div>
            </div>
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </BrowserRouter>
    </>
  );

}

const mapsStateToProps = state => {
  return {
    isPlannerVisible: state.common.isPlannerVisible
  };
}

const mapDispatchToProps = dispatch => {
  return {
    setPlanner: (isPlannerVisible) => dispatch({ type: actionTypes.PLANNER_VISIBLE, isPlannerVisible: isPlannerVisible })
  }
}

export default connect(mapsStateToProps, mapDispatchToProps)(App);
